import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/usingthesite",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Using the Site")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/dashboards",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Dashboards")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/faqs",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "FAQs")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/changelog",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Change Log")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Frequently Asked Questions", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "uk-text-lead uk-margin-large-bottom" }, " Here are answers to most common questions about using Matrix for Direct Sell (MxB-DS). ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { id: "target1" }, " General Options ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " The data is stored in a centralized database in the \"cloud\" on Empact IT's Azure infrastructure. ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " Data in MxB-DS is updated each evening at 2:30AM Eastern Time. This update includes both Steelcase SAP and Dealer Hedberg System data. ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " There is security on the database itself and within the Direct Sell console. Within the console, only those with access to the tool will be able to login. Once a user logs into the tool, the dashboards they can see and the data within those dashboards is also tied to their login. ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, " Dealers who subscribe to MxB-DS will be able to see only the data associated with their dealership. "),
    /*#__PURE__*/_createElementVNode("li", null, " Steelcase will be able to see data for all dealers who subscribe to MxB-DS. ")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " The Online Help should be the first place you go to seek assistance with understanding the information on the various Dashboards in MxB–DS. "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" If your question or issue is with the application, please email "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@empactit.com" }, "support@empactit.com"),
    /*#__PURE__*/_createTextVNode(". ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " If your question or issue is regarding your Direct Sell Order at Steelcase, you should contact your Order Fulfillment Team. ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "Dashboards", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " The Transaction Dashboard includes both Direct Sell quotes and orders. Examples of information available are: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Potential Direct Sell business (quotes),"),
    /*#__PURE__*/_createElementVNode("li", null, "Line Count Discrepancies,"),
    /*#__PURE__*/_createElementVNode("li", null, "Total Extended Sell for the Direct Sell Order, and"),
    /*#__PURE__*/_createElementVNode("li", null, "Order Status.")
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " The Transactions Detail Dashboard provides line level information about the quotes and orders on the Transactions Dashboard. It is here that you will see which lines have exceptions or warnings and descriptions of the issues. Examples of the information available are: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "The line number for missing line(s),"),
    /*#__PURE__*/_createElementVNode("li", null, "Which line(s) have different extended sells in SAP vs Hedberg, and"),
    /*#__PURE__*/_createElementVNode("li", null, "What the expected arrival date is for the product")
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " The Reconciliation Dashboard includes Direct Sell orders in process. Examples of information available are: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Missing acknowledgments for non-Steelcase product and service lines, and"),
    /*#__PURE__*/_createElementVNode("li", null, "Estimated commission differences.")
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " The Reconciliation Detail Dashboard provides line level information about the quotes and orders on the Reconciliation Dashboard. It is here that you will see which lines have exceptions or warnings and descriptions of the issues. Examples of information available are: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "The line number of lines missing Steelcase Acknowledgments, and"),
    /*#__PURE__*/_createElementVNode("li", null, "Which line(s) have different estimated commissions in SAP vs Hedberg.")
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " The Commission Dashboard includes Direct Sell orders that are in process. Examples of information available are: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Total of all Steelcase Commission Credit Memos for a single order,"),
    /*#__PURE__*/_createElementVNode("li", null, "Steelcase Credit Memo detail for the order lines, and "),
    /*#__PURE__*/_createElementVNode("li", null, " Discrepancies between the dealer's expected commission and the actual commission received ")
  ])
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " All data with \"DLR or Dealer\" originates in the dealer's the Dealers Hedberg System (The Dealer's Hedberg System). "),
  /*#__PURE__*/_createElementVNode("p", null, "All data with \"STC\" or Steelcase originates in Steelcase's SAP System."),
  /*#__PURE__*/_createElementVNode("p", null, "For example:"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, " \"DLR Ext Sell\" is the extended sell on the dealer's the Dealer's Hedberg System Order. "),
    /*#__PURE__*/_createElementVNode("li", null, " \"STC Ext Sell\" is the extended sell on the Steelcase order as indicated in SAP. ")
  ])
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", null, "Exceptions and Warnings", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Exception:"),
    /*#__PURE__*/_createTextVNode(" There is a clear difference between the information in the Dealer's Hedberg System and SAP."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("strong", null, "Warning:"),
    /*#__PURE__*/_createTextVNode(" There is an issue between the information in the Dealer's Hedberg System and SAP, but it may not be a problem."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("strong", null, "OK:"),
    /*#__PURE__*/_createTextVNode(" No issue."),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " Alerts identify the number of lines on the order with an issue. If the Status is \"Exception\" the Alert line count will include the number of lines with an exception or a warning. If the Status is \"Warning\" the Alert line count will include only lines with a warning. ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " In determining if the status will be a Warning or Exception, the higher-level issue will be reported. ")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " To identify which lines, have exceptions or warnings and what they are you will need to go to the Detail View for the Dashboard. Here you will see the Line Status Description detailing the exceptions and/or warnings. ")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " No, all Status Descriptions will not appear at the line level. For example, if the status description is \"STC Order/Line not found\", the line will also be \"Missing STC Ack in SAP\", \"Missing STC Ack in Hedberg\", \"Ext. Sell not matching\", etc. Since the line is missing, the other issues are the result of it being missing. Once the missing line issue is resolved, other statuses will appear as appropriate. ")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("strong", null, "Bar", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("strong", null, "Definition", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Quotes ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" The number of Direct Sell Quotes and their total extended sell dollars. ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" STC Orders ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" The number of Direct Sell Orders Steelcase has in SAP and their total extended sell dollars. ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" DLR Orders ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" The number of Direct Sell Orders the Dealer has in their Hedberg System and their total extended sell dollars. ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Difference ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" The difference between the number of STC and Dealer Orders and extended sell. ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Missing Customer PO ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" The number of orders without a Customer PO# and their extended sell (only counts the order once). ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Quotes ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" The number of Direct Sell Quotes and their total extended sell dollars. ")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, "Bar", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("strong", null, "Definition", -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Line Count Discrepancies ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" The number of Direct Sell Orders with missing lines and their total extended sell dollars. ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Line Detail Discrepancies ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" The number of Direct Sell Orders Lines with exceptions and their extended sell. ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Missing STC Acknowledgments ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" The number of Direct Sell Orders Lines with the Missing STC Ack Warning and their extended sell. ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Missing Customer PO ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" The number of orders without a Customer PO# and their extended sell (only counts the order once). ")
const _hoisted_50 = /*#__PURE__*/_createElementVNode("strong", null, "Bar", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("strong", null, "Definition", -1)
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" No STC CM (DLR Comm Inv Exists) ")
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" The number of Direct Sell Orders without a STC Credit Memo but there is a DLR Commission Invoice and their total extended sell dollars. ")
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" No DLR Comm Inv (STC CM Rec’d) ")
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" The number of Direct Sell Orders without a DLR Commission Invoice but there is a STC Credit Memo and their extended sell. ")
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Commission Discrepancy ")
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" The number of Direct Sell Orders and the commission discrepancy where there is both a STC Credit Memo and a DLR Commission invoice, but the amounts are different. ")
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Missing STC CM in The Dealers Hedberg System ")
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" The number of Direct Sell Orders and the dollar value of the Steelcase Credit Memos that Steelcase has but can’t be found in the Dealer’s Hedberg System Accounts Payable Module. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_DashboardLayout = _resolveComponent("DashboardLayout")!

  return (_openBlock(), _createBlock(_component_DashboardLayout, null, {
    header: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: 20,
        class: "pad-v-20"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider, { class: "no-border" }),
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _createVNode(_component_el_collapse, {
                modelValue: _ctx.activeNames,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeNames) = $event)),
                onChange: _ctx.handleChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_collapse_item, {
                    title: "Where is the data stored for MxB–DS?",
                    name: "1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "When is the data updated?",
                    name: "2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "What security is used to product the data?",
                    name: "3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "Who can access the data?",
                    name: "4"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "If I have a question or issue, what do I do?",
                    name: "5"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"]),
              _createVNode(_component_el_divider, { class: "no-border" }),
              _hoisted_13,
              _createVNode(_component_el_collapse, {
                modelValue: _ctx.activeNames,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeNames) = $event)),
                onChange: _ctx.handleChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_collapse_item, {
                    title: "What’s on the Transactions Dashboard?",
                    name: "1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "What's on the Transactions Detail Dashboard?",
                    name: "2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "What’s on the Reconciliation Dashboard?",
                    name: "3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "What’s on the Reconciliation Detail Dashboard?",
                    name: "4"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "What’s on the Commission Dashboard?",
                    name: "5"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "Where is the data coming from that appears on the Direct Sell Console?",
                    name: "6"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"]),
              _createVNode(_component_el_divider, { class: "no-border" }),
              _hoisted_20,
              _createVNode(_component_el_collapse, {
                modelValue: _ctx.activeNames,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeNames) = $event)),
                onChange: _ctx.handleChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_collapse_item, {
                    title: "What's the difference between an Exception and a Warning?",
                    name: "1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "What are the Alerts?",
                    name: "2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "If an order or line has both Exceptions or Warning, which status will appear?",
                    name: "3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "How will I know what the issues are with the lines?",
                    name: "4"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "Will all Status Descriptions that apply appear with the line?",
                    name: "5"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "What do the bars on the Direct Sell Transaction Chart mean?",
                    name: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_27
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_28
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_29
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_30
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_31
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_32
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_33
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_34
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_35
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            class: "el-col el-col-4",
                            span: 8
                          }, {
                            default: _withCtx(() => [
                              _hoisted_36
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, {
                            class: "el-col el-col-8",
                            span: 16
                          }, {
                            default: _withCtx(() => [
                              _hoisted_37
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_38
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_39
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "What do the bars on the Direct Sell Reconciliation Chart mean?",
                    name: "7"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_40
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_41
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_42
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_43
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_44
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_45
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_46
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_47
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_48
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_49
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "What do the bars on the Direct Sell Commission Chart mean?",
                    name: "8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_50
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_51
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_52
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_53
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_54
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_55
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_56
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_57
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _hoisted_58
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _hoisted_59
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}